<template>
  <div class="col-4">
    <div class="integration-card">
      <div class="integration-card-header">
        <img :src="$image('assets/' + item.typeInfo.icon)" :alt="item.typeInfo.title"/>

        <div class="header-text">
          <h4 class="integration-card-title">{{ item.typeInfo.title }}</h4>
          <h5 class="integration-card-subtitle">{{ item.typeInfo.subtitle }}</h5>

          <div
              v-if="item.data.isActive"
              class="tag--default tag--blue tag--integration"
              data-tooltip-position="top"
              data-tooltip="Successfully Authorized"
          >
            Authorized
          </div>
        </div>
      </div>
      <div class="integration-card-body">
        <div class="content" v-html="item.typeInfo.content"></div>
      </div>
      <div class="integration-card-footer">
        <ButtonElement v-if="item.data.isActive"
                       class="btn--ms btn--neutral btn--medium btn--md"
                       @clickOnButton="integrationDetail()">
          <LucideIcon icon="Settings"/>
          Edit Integration
        </ButtonElement>

        <ButtonElement v-else
                       class="btn--ms btn--accent btn--md"
                       @clickOnButton="startIntegration()">
          Connect to {{ item.typeInfo.title }}
        </ButtonElement>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue'
import ButtonElement from '@shared/components/elements/button/button.element.vue'
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useIntegrationStore} from "@domains/settings/stores/integration.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {useRouter} from 'vue-router'

export default defineComponent({
  name: 'IntegrationCardWidget',
  components: {
    ButtonElement
  },
  setup() {
    const router = useRouter()
    const generalStore = useGeneralStore();

    return {
      router,
      generalStore,
    }
  },
  props: {
    item: {
      type: Object as PropType<any>,
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    integrationDetail() {
      const type = this.item.typeInfo.type.toLowerCase()
      this.router.push(`integrations/${type}`)
    },
    startIntegration() {
      const wsStore = useWorkspaceStore();
      const intStore = useIntegrationStore();
      if (this.item.data && this.item.data.isActive) {
        this.integrationDetail()
      } else {
        const payload = {
          workspaceId: wsStore.getSelectedWorkspaceId,
          integrationType: this.item.typeInfo.type
        }

        intStore.getAuthorizeUrl(payload)
            .then((response) => {
              window.location.href = response
            })
            .catch((error) => console.log(error))
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.integration-card {
  position: relative;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  box-shadow: var(--card-shadow);
  padding: var(--space-16);
  margin-bottom: var(--space-16);
  border-radius: $br-sm;

  &:hover {
    box-shadow: var(--card-shadow-active);
  }

  &-header {
    display: flex;
    align-items: center;

    .header-text {
      margin-left: var(--space-16);

      h4 {
        font-size: var(--fs-14);
        font-weight: 500;
        margin-top: var(--space-8);
        margin-bottom: var(--space-4);
      }

      h5 {
        font-size: var(--fs-12);
        color: var(--text-neutral);
      }
    }

    .tag--integration {
      width: auto;
      height: 25px;
      position: absolute;
      right: var(--space-16);
      top: var(--space-16);
      line-height: 20px;
    }


    button {
      margin-left: auto;
    }
  }

  &-body {
    .content {
      margin-top: var(--space-16);
      margin-bottom: var(--space-16);
      font-size: var(--fs-12);
      color: var(--text-neutral);
    }
  }

  &-footer {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-8);


    button {
      margin-left: auto;
    }
  }
}

.popup__body {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: var(--space-0) var(--space-40) var(--space-40);
  overflow-y: hidden;
  max-height: 600px;

  h2 {
    font-size: var(--fs-18);
    margin-bottom: var(--space-0);
  }

  h3 {
    font-size: var(--fs-14);
    margin-bottom: var(--space-0);
  }

  h4 {
    margin-bottom: var(--space-0);
  }

  p {
    font-size: var(--fs-14);
    line-height: 22px;
  }

  pre {
    display: flex;
    padding: var(--space-16);
    border-radius: $br-md;
    margin: var(--space-0);
    background: var(--light-300);
    position: relative;
    box-shadow: var(--card-shadow);
    border: 1px solid var(--card-border);
  }

  code {
    position: relative;
    z-index: 1;
    width: max-content;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .popup__api {
    background: var(--card-bg);
    box-shadow: var(--card-shadow);
    border: 1px solid var(--card-border);
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: var(--space-8);
    padding: var(--space-4);
    border-radius: $br-md;
    position: relative;
    z-index: 2;

    &-button{
      width: 100%;
      display: flex;
      justify-content: center;
      gap: var(--space-4);
    }
    &-token{
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: var(--space-8);
      width: 100%;
      &-empty{
        display: flex;
        align-items: center;
        color: var(--text-neutral);
        font-size: var(--fs-12);
        margin-right: var(--space-16);
      }
      h5{
        white-space: nowrap;
        font-weight: 500;
        margin: var(--space-0);
        padding: var(--space-0) var(--space-8);
        span{
          font-size: var(--fs-12);
          color: var(--text-neutral);
        }
      }
    }
    &-form{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0;
      border-radius: $br-sm;
      height: 40px;
      padding: var(--space-0) var(--space-4) var(--space-0) var(--space-0);
      width: 100%;
      background-color: var(--form-bg);
      border: 1px solid var(--form-border);
      box-shadow: none !important;
      &-input{
        width: 100%;
        height: 40px !important;
        font-size: var(--fs-14);
        padding: 0 10px;
        margin: var(--space-0);
        border: 0;
        letter-spacing: -0.6px;
        line-height: 20px;
        background-color: transparent;
        z-index: 1;
        position: relative;
        text-overflow: ellipsis;
        color: var(--text-dark);
      }
      &-button{
        display: flex;
        gap: var(--space-4);
      }
    }
  }

  .popup__connect{
    display: flex;
    height: 24px;
    &-left{
      width: 50%;
    }
    &-right{
      border-left: 2px solid var(--border-neutral);
      width: 50%;
    }
  }

  .popup--code {
    position: relative;

    .btn--copy {
      position: absolute;
      right: var(--space-16);
      bottom: var(--space-16);
      z-index: 1;
    }

    .last-comment {
      padding-bottom: var(--space-16);
      display: inline-block;
    }

    .code-comment {
      color: var(--code-comment);
    }

    .code-text {
      color: var(--code-dark);
    }

    .code-accent {
      color: var(--code-accent);
    }

    .code-secondary {
      color: var(--code-secondary);
    }
  }

}


</style>
